import { Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

/**
 * Parent layout route for account pages.
 * Inside AppLayout — the shell is already rendered, so loading shows spinner only.
 */
const AccountRoute = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return <Outlet />;
};

export default AccountRoute;
